import { useCallback, useEffect, useState } from "react";
import { useData } from "./DataProvider";
import type { Richiesta } from "./richieste";

/** Carica una singola richiesta; `reload` per rileggerla dopo un salvataggio. */
export function useRichiesta(id: number) {
  const { richieste } = useData();
  const [item, setItem] = useState<Richiesta | null>();
  const [error, setError] = useState<unknown>();

  const reload = useCallback(async () => {
    setError(undefined);
    try {
      setItem((await richieste.get(id)) ?? null);
    } catch (e) {
      setError(e);
    }
  }, [richieste, id]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { item, error, reload };
}
